"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

require("../../assets/css/components/notificacao/Message.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Message = function (_React$Component) {
    _inherits(Message, _React$Component);

    function Message() {
        _classCallCheck(this, Message);

        return _possibleConstructorReturn(this, (Message.__proto__ || Object.getPrototypeOf(Message)).apply(this, arguments));
    }

    _createClass(Message, [{
        key: "getClose",
        value: function getClose() {
            this.alerta.setAttribute('style', 'display: none');
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                "div",
                { ref: function ref(message) {
                        return _this2.alerta = message;
                    }, role: "alert", className: 'message  mdl-cell mdl-cell--12-col ' + (this.props.type ? this.props.type : "") },
                _react2.default.createElement(
                    "div",
                    { className: "message-icon", "aria-hidden": "true" },
                    _react2.default.createElement("span", null)
                ),
                _react2.default.createElement(
                    "div",
                    { className: "message-body" },
                    _react2.default.createElement(
                        "strong",
                        null,
                        this.props.title
                    ),
                    _react2.default.createElement(
                        "small",
                        null,
                        this.props.message
                    )
                ),
                _react2.default.createElement(
                    "button",
                    { type: "button", className: "message-close", onClick: this.getClose.bind(this), "aria-label": "Fechar alerta" },
                    _react2.default.createElement(
                        "div",
                        { className: "tooltip", "aria-hidden": "true" },
                        _react2.default.createElement(
                            "span",
                            null,
                            "Fechar Alerta"
                        )
                    )
                )
            );
        }
    }]);

    return Message;
}(_react2.default.Component);

exports.default = Message;


Message.propTypes = {
    title: _propTypes2.default.string,
    message: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
    type: _propTypes2.default.oneOf(['warning', 'info', 'success', 'error']),
    onDismiss: _propTypes2.default.func
};


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/notificacao/Message.js
// module id = 589
// module chunks = 0